
const config = {
}

if (window.location.hostname !== 'localhost') {
  config.stripeKey = 'pk_live_51RMWzNIi6sPQBbrwbGnUplSSkTymY2Q3EOJIb6zqAXzOIYZrl3LLRoQ4zTW7HH5du0yMrET9kw5vAT0NRNPfp39e001EHapOYV'
  config.prices = {
    monthly: 'price_1RMls5Ii6sPQBbrwEHaNjyPU',
    yearly: 'price_1RMls5Ii6sPQBbrwkP0M8hVt'
  }
} else {
  config.stripeKey = 'pk_test_51RMWzYIbJmkEa7jMTv4WxmkqgRKFUqZRqALBNquNj8H9HBUTvETC6rNI4IdORQNWI2xyPb0kW0FAXK65RnDvWShG00df1aTS1U'
  config.prices = {
    monthly: 'price_1RMlqJIbJmkEa7jMvyHIVLF3',
    yearly: 'price_1RMlqJIbJmkEa7jMhPk7TmNh'
  }
}

export default config
